export default function BuyingGuideCard() {
  return (
    <section className="rounded-xl border border-neutral-200 bg-white shadow-sm p-4 md:p-5">
      <h3 className="text-sm font-semibold text-neutral-900 mb-2">Invoice setup quick guide</h3>
      <p className="text-sm text-neutral-600 mb-3">
        New to invoicing? Start here. Learn the essentials for numbering, terms, taxes and templates.
      </p>
      <ul className="text-sm text-neutral-700 list-disc pl-4 space-y-1">
        <li><a className="hover:underline" href="/generator">Create an invoice fast</a></li>
        <li><a className="hover:underline" href="/blog/freelance-invoicing-tools">Best invoicing tools</a></li>
        <li><a className="hover:underline" href="/blog/5-common-invoicing-mistakes">Common mistakes to avoid</a></li>
      </ul>
    </section>
  );
}
